import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppJoin from "./AppJoin";
import AppFormPage from "./AppFormPage";
import AppLayout from './AppLayout';
import Play from "components/Room/Play"
import Login from '../Forms/Login';
import ForgotPassword from '../Forms/ForgotPassword';
import TermsConditions from '../policy/TermsConditions';

export default class AppView extends Component {
    static displayName = AppView.name;

    constructor(props) {
        super(props);
        this.state = {
            platform: 'unknown', // 'android', 'ios', or 'web'
        };
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        if (params.has("clearapp")) {
            localStorage.removeItem("IsAppView");
            window.location.href = "/";
        }

        // Detect platform
        this.detectPlatform();
    }

    detectPlatform = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            this.setState({ platform: 'android' });
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            this.setState({ platform: 'ios' });
        }
    }

    render() {
        return (
            <AppLayout>
                <React.Fragment>
                    <Routes>
                        <Route path={"/"} key={'page-1'} element={
                            <AppFormPage>
                                <AppJoin />
                            </AppFormPage>
                        } />;

                        <Route path={"/App"} key={'page-1'} element={
                            <AppFormPage>
                                <AppJoin />
                            </AppFormPage>
                        } />;

                        <Route path={"/join"} key={'page-1'} element={
                            <AppFormPage>
                                <AppJoin />
                            </AppFormPage>
                        } />;

                        <Route path={"/App/play"} key={'page-2'} element={
                            <Play />
                        } />;

                        <Route path={"/login"} key={'page-3'} element={
                            <AppFormPage is="login">
                                <Login noQR={true}
                                    redirectAppleLogin={this.state.platform !== 'ios'}
                                    hideGoogleLogin={this.state.platform === 'ios'}
                                    redirectGoogleLogin={this.state.platform !== 'android'}
                                />
                            </AppFormPage>
                        } />;

                        <Route path={"/forgot-password"} key={'page-4'} element={
                            <AppFormPage>
                                <ForgotPassword />
                            </AppFormPage>
                        } />;

                        <Route path={"/terms"} key={'page-5'} element={
                            <TermsConditions isApp={true} />
                        } />;

                    </Routes>
                </React.Fragment>
            </AppLayout>
        );
    }
}
